<template>
  <div>
    <template v-if="!$route.meta.allowAnonymous">
      <v-app id="inspire">
        <div class="app-container">
          <navigation :toggle="drawer" />
          <v-main>
            <breadcrumbs />
            <router-view class="px-1 px-md-10" />
            <!-- <page-footer /> -->
          </v-main>
        </div>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive> <router-view class="px-3"></router-view> </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import auth from "@/auth/auth.js";
export default {
  name: "App",
  data() {
    return {
      drawer: true
    };
  },
  beforeMount() {
    this.$store.commit("auth/SET_TOKEN", VueCookie.get("token"));
    this.$store.commit(
      "auth/SET_USER",
      auth.decodeToken(VueCookie.get("token"))
    );
  }
};
</script>

<style>
.v-btn:hover:before {
  color: transparent !important;
}
</style>
<style lang="scss" src="./App.scss"></style>
